import '@testing-library/jest-dom';
import { render, screen } from '@testing-library/react';

import { StatusBadge } from './StatusBage';

describe('StatusBadge', () => {
  it('should render with message', () => {
    render(<StatusBadge label="Status message" />);
    expect(screen.getByText('Status message')).toBeInTheDocument();
  });

  it('should render with highContract', () => {
    render(<StatusBadge label="Status message" highContrast={true} />);
    expect(screen.getByText('Status message')).toHaveClass('statusbadge--high-contrast');
  });
});
